import { ChangeCell } from "@similarweb/pro-logic-components";

/**
 * Rank-delta value. Renders through `ChangeCell` so the up/down arrows and colors match the
 * rest of the app's change cells — only the value is formatted as an integer position delta
 * instead of a percentage. Positive means the site climbed.
 * Shared by the Rank Change table column and the Top movers widgets.
 */

interface IRankChangeValueProps {
    /** `null`/`undefined` means no comparable prior rank, so there is no delta to show. */
    value?: number | null;
}

export const RankChangeValue = ({ value }: IRankChangeValueProps) => (
    <ChangeCell
        value={value ?? undefined}
        formattedValue={value ? String(Math.abs(value)) : undefined}
        // Holding position is a real zero; a missing delta reads as a dash.
        noChangeSign={value === 0 ? "0" : "-"}
    />
);

RankChangeValue.displayName = "RankChangeValue";
